import { useTheme } from '@pinwheel/origami';
import React from 'react';
import CircledCheck from '../assets/CircledCheck';
import { selectLinkTokenPayload } from '../state/slices/slice-link-params';
import { checkHackyWorkspace } from '../utils/hacky-workspace-customizations';
import { useAppSelector } from '../state';
var CircledCheckImage = function () {
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var workspaceName = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.workspaceName;
    var resolveColor = useTheme().resolveColor;
    var isFlow = checkHackyWorkspace('Flow', workspaceName) ||
        checkHackyWorkspace('Flow Theme Testing', workspaceName);
    var iconColor = isFlow
        ? resolveColor({
            type: 'theme',
            colorLegacy: 'Secondary/50',
            colorNext: 'success/default',
        })
        : resolveColor({
            type: 'theme',
            colorLegacy: 'Neutral/80',
            colorNext: 'neutral/default',
        });
    return React.createElement(CircledCheck, { size: 80, color: iconColor });
};
export default CircledCheckImage;
